import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import { Flex, UiButton } from '@shared/ui';

import { ModalAddContext } from './ModalAdd';

export const AccountAddFooter = () => {
    const { onShowModal, onSubmitButton } = useContext(ModalAddContext);

    const { t } = useTranslation();

    return (
        <Flex fullWidth justify="between">
            <UiButton
                onClick={onShowModal}
                btnColor="secondary"
                btnText={t('AccountAddFooter.return.footer.cancel')}
            />
            <UiButton
                onClick={onSubmitButton}
                btnText={t('AccountAddFooter.return.footer.create')}
            />
        </Flex>
    );
};
